var _desc, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.32959,
    height: 20.000015,
    viewBox: "0 0 41.3296 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.2 7L0 0.45L0.94 0.45L1.99 3.68C2.28 4.56 2.54 5.36 2.72 6.13L2.74 6.13C2.93 5.37 3.21 4.54 3.51 3.69L4.66 0.45L5.59 0.45L3.17 7L2.2 7Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.05 4.81C6.07 5.96 6.83 6.44 7.72 6.44C8.35 6.44 8.73 6.33 9.06 6.2L9.21 6.81C8.9 6.94 8.37 7.1 7.6 7.1C6.1 7.1 5.21 6.15 5.21 4.73C5.21 3.31 6.07 2.19 7.48 2.19C9.07 2.19 9.49 3.54 9.49 4.41C9.49 4.58 9.47 4.72 9.46 4.81L6.05 4.81ZM8.64 4.19C8.65 3.65 8.41 2.8 7.42 2.8C6.52 2.8 6.13 3.6 6.06 4.19L8.64 4.19Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.19 3.77C10.19 3.21 10.18 2.74 10.15 2.3L10.92 2.3L10.95 3.22L10.99 3.22C11.21 2.59 11.74 2.19 12.34 2.19C12.44 2.19 12.51 2.2 12.59 2.22L12.59 3.03C12.5 3.01 12.41 3 12.29 3C11.66 3 11.22 3.46 11.1 4.1C11.08 4.22 11.06 4.35 11.06 4.5L11.06 7L10.19 7L10.19 3.77Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.09 0.98C14.1 1.27 13.88 1.5 13.53 1.5C13.22 1.5 13 1.27 13 0.98C13 0.67 13.23 0.44 13.55 0.44C13.88 0.44 14.09 0.68 14.09 0.98ZM13.11 2.3L13.99 2.3L13.99 7L13.11 7L13.11 2.3Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.15 7L15.15 2.95L14.47 2.95L14.47 2.3L15.15 2.3L15.15 2.07C15.15 1.41 15.3 0.81 15.71 0.43C16.04 0.12 16.48 0 16.9 0C17.21 0 17.48 0.06 17.65 0.13L17.53 0.79C17.4 0.73 17.22 0.69 16.97 0.69C16.21 0.69 16.02 1.33 16.02 2.04L16.02 2.3L17.2 2.3L17.2 2.95L16.02 2.95L16.02 7L15.15 7L15.15 7Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.05 0.98C19.06 1.27 18.84 1.5 18.49 1.5C18.18 1.5 17.96 1.27 17.96 0.98C17.96 0.67 18.19 0.44 18.51 0.44C18.84 0.44 19.05 0.68 19.05 0.98ZM18.07 2.3L18.95 2.3L18.95 7L18.07 7L18.07 2.3Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.51 4.81C20.53 5.96 21.29 6.44 22.18 6.44C22.81 6.44 23.19 6.33 23.52 6.2L23.67 6.81C23.36 6.94 22.83 7.1 22.06 7.1C20.56 7.1 19.66 6.15 19.66 4.73C19.66 3.31 20.53 2.19 21.94 2.19C23.53 2.19 23.95 3.54 23.95 4.41C23.95 4.58 23.93 4.72 23.92 4.81L20.51 4.81ZM23.1 4.19C23.11 3.65 22.87 2.8 21.87 2.8C20.98 2.8 20.59 3.6 20.52 4.19L23.1 4.19Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.84 0.1L28.84 5.79C28.84 6.21 28.85 6.68 28.88 7L28.09 7L28.05 6.19L28.03 6.19C27.76 6.71 27.17 7.11 26.37 7.11C25.2 7.11 24.29 6.15 24.29 4.72C24.28 3.15 25.29 2.19 26.47 2.19C27.22 2.19 27.72 2.53 27.94 2.91L27.96 2.91L27.96 0.1L28.84 0.1L28.84 0.1ZM27.96 4.21C27.96 4.11 27.95 3.96 27.92 3.85C27.79 3.31 27.31 2.86 26.64 2.86C25.73 2.86 25.19 3.64 25.19 4.68C25.19 5.63 25.67 6.42 26.62 6.42C27.22 6.42 27.76 6.04 27.92 5.4C27.95 5.28 27.96 5.16 27.96 5.03L27.96 4.21Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.12 7C32.14 6.68 32.16 6.2 32.16 5.79L32.16 0.1L33.03 0.1L33.03 3.06L33.05 3.06C33.36 2.53 33.92 2.19 34.71 2.19C35.91 2.19 36.77 3.16 36.76 4.59C36.76 6.27 35.66 7.11 34.58 7.11C33.87 7.11 33.31 6.85 32.95 6.22L32.92 6.22L32.88 7L32.12 7L32.12 7ZM33.03 5.12C33.03 5.22 33.05 5.33 33.07 5.43C33.24 6.02 33.75 6.43 34.39 6.43C35.32 6.43 35.87 5.7 35.87 4.62C35.87 3.68 35.37 2.87 34.42 2.87C33.82 2.87 33.26 3.27 33.08 3.92C33.06 4.02 33.03 4.13 33.03 4.27L33.03 5.12L33.03 5.12Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.72 2.3L38.78 5.08C38.89 5.39 39.02 5.76 39.09 6.04L39.12 6.04C39.21 5.76 39.31 5.4 39.43 5.06L40.39 2.3L41.32 2.3L40 5.65C39.37 7.26 38.93 8.09 38.33 8.6C37.9 8.97 37.47 9.11 37.25 9.15L37.03 8.43C37.25 8.36 37.54 8.23 37.8 8.01C38.04 7.83 38.34 7.5 38.54 7.06C38.58 6.97 38.61 6.9 38.61 6.86C38.61 6.81 38.59 6.74 38.55 6.63L36.76 2.3L37.72 2.3L37.72 2.3Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.46 10.21L16.33 19.84L18.91 19.84L21.03 10.21L18.46 10.21Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.41 12.88C24.42 12.54 24.76 12.17 25.5 12.07C25.87 12.03 26.89 11.99 28.04 12.5L28.5 10.46C27.88 10.24 27.08 10.03 26.09 10.03C23.54 10.03 21.75 11.34 21.74 13.22C21.72 14.6 23.02 15.38 23.99 15.84C24.99 16.31 25.33 16.61 25.32 17.04C25.32 17.68 24.53 17.97 23.79 17.98C22.49 18 21.74 17.64 21.14 17.37L20.68 19.48C21.27 19.75 22.39 19.98 23.54 20C26.24 20 28.01 18.7 28.02 16.7C28.03 14.16 24.39 14.02 24.41 12.88Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.86 16.43L33.23 12.82L34 16.43L31.86 16.43ZM32.84 10.21C32.35 10.21 31.93 10.49 31.74 10.92L27.88 19.84L30.59 19.84L31.13 18.41L34.42 18.41L34.73 19.84L37.12 19.84L35.04 10.21L32.84 10.21Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M14.34 10.21L11.82 16.79L11.55 15.46C11.08 13.92 9.62 12.24 7.98 11.41L10.3 19.85L13.02 19.85L17.07 10.21L14.34 10.21Z",
    fill: "#00579F",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M9.52 10.21L5.3 10.21L5.26 10.41C8.55 11.23 10.67 13.21 11.57 15.58L10.7 11.04C10.55 10.41 10.09 10.23 9.52 10.21Z",
    fill: "#FAA61A",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4d1984c38fb28bbfce2e2421113ccf88.svg";
export { ForwardRef as ReactComponent };